import {
    getColor, StyleFunctionProps
} from '@chakra-ui/theme-tools';

/**
 * Unknown color tokens, need to add to base theme?.
 */
const disabledColor0 = '#ADB9C7';
const disabledColor1 = '#CBD3DC';
// Using box shadow so the change in border size for active does not
// cause a reflow of the size of the input.

export const baseControlTheme = (props: StyleFunctionProps) => ({
    borderColor: 'none',
    border: 'none',
    borderBottom: 'none',
    boxSizing: 'border-box',
    boxShadow: `inset 0 0 0 1px ${getColor(props.theme, 'neutral.300')}`,
    fontStyle: 'normal',
    fontWeight: 'normal',
    color: 'neutral.900',
    outline: 'none',
    _disabled: {
        border: '1px dashed',
        borderColor: disabledColor1,
        cursor: 'not-allowed',
        boxShadow: 'none !important',
        color: disabledColor0
    },
    _hover: { boxShadow: `inset 0 0 0 1px ${getColor(props.theme, 'neutral.600')}` },
    _readOnly: { userSelect: 'all' },
    _invalid: { boxShadow: `inset 0 0 0 1px ${getColor(props.theme, 'error.700')}` },
    _focus: {
        zIndex: 1,
        boxShadow: `inset 0 0 0 2px ${getColor(props.theme, 'primary.500')}`
    }
});
